<template>
    <v-app component="app" :popupvisible="getIsAnyPopupVisible">
        <app-header></app-header>

        <transition :name="transitionName">
            <router-view view="main"></router-view>
        </transition>

        <camera />

        <popup :name="'auth'" :visible="getIsAuthPopupVisible" @open="openAuthPopup" @close="closeAuthPopup">
            <login-form @success="loginSuccess" />
        </popup>
    </v-app>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex';
import EventBus from '@lib/EventBus';

import AppHeader from '@/components/AppHeader/AppHeader.vue';
import Camera from '@/components/Camera/Camera.vue';

import LoginForm from '@/components/Login/LoginForm.vue';

export default {
    name: 'App',

    data() {
        return {
            transitionName: 'zoomIn',
        };
    },

    created() {
        EventBus.$on('auth.login.success', () => {
            this.$store.commit('setActorAccessToken', null);
        });

        this.loadAppStats();
    },

    mounted() {
        window.addEventListener('resize', this.onResize);
        this.onResize();
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.onResize);
        EventBus.$off('auth.login.success');
    },

    methods: {
        ...mapActions(['openAuthPopup', 'closeAuthPopup', 'loadAppStats']),
        ...mapMutations(['setScreenHeight']),

        switchTransition(name) {
            this.transitionName = name;
        },

        loginSuccess() {
            this.closeAuthPopup();
            var name = window.matchMedia('(min-width: 768px)').matches ? 'profile-voice' : 'profile-intro';
            this.$router.push({ name });
        },

        onResize() {
            this.setScreenHeight(window.innerHeight);
        },
    },

    computed: {
        ...mapGetters(['getIsAnyPopupVisible', 'getIsAuthPopupVisible']),
    },

    components: {
        AppHeader,
        Camera,
        LoginForm,
    },
};
</script>

<style src="~/material-icons/iconfont/material-icons.css"></style>
<style lang="less">
[component='app'] {
    [view='main'] {
        // z-index: 20;
    }

    .container {
        // transition: 0.5s;
        // width: 100%;
    }

    &[popupvisible] {
        // presunute, ale hodi sa to tu
        // GLobálna zmena dizajnu pri popupe
    }
}
</style>
